import { CSSProperties } from 'react'

// --- app type scale (design-cohesion F2) ---
// The single source of the app's font-size/line-height scale. Consumed by the
// app's own Typography component (`src/storybook/components/Typography`, which
// re-exports these from its `config.ts` so its ~430 call sites keep the import
// they have) and by the shadcn half of the `src/antd/Typography` seam; do not
// define variant sizes anywhere else.
//
// It lives HERE rather than beside the storybook component so that
// `src/antd/**` — the compat seam — does not have to reach into
// `src/storybook/**` for a token, and because `update-design` serves the same
// module from this same path with the same values. Moving it was the whole
// change: every number below is byte-identical to what
// `src/storybook/components/Typography/config.ts` shipped before.

export type TVariant =
  | 'header-32'
  | 'header-24'
  | 'subHeader-20'
  | 'subHeader-16'
  | 'body-14'
  | 'body-12'
  | 'unset'

export const variants: Record<TVariant, CSSProperties> = {
  'header-32': {
    fontSize: `2rem`,
    lineHeight: 0.875,
  },
  'header-24': {
    fontSize: '1.5rem',
    lineHeight: 1.16,
  },
  'subHeader-20': {
    fontSize: `1.25rem`,
    lineHeight: 1.4,
  },
  'subHeader-16': {
    fontSize: `1rem`,
    lineHeight: 1.5,
  },
  'body-14': {
    fontSize: `0.875rem`,
    lineHeight: 1.4,
  },
  'body-12': {
    fontSize: `0.75rem`,
    lineHeight: 1.3,
  },
  unset: {},
}

export type TFontWeight = `heavy` | `semi-bold` | 'medium' | `regular`

export const fontWeights: Record<TFontWeight, CSSProperties> = {
  heavy: {
    fontWeight: 800,
  },
  'semi-bold': {
    fontWeight: 600,
  },
  medium: {
    fontWeight: 500,
  },
  regular: {
    fontWeight: 400,
  },
}
